import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useActiveSession } from "@/hooks/useActiveSession";
import type { SessionRecord } from "@/hooks/useSessions";

interface StartSessionButtonProps {
  session: SessionRecord;
  size?: "sm" | "default" | "lg" | "icon";
  variant?: "default" | "ghost" | "outline";
  className?: string;
  label?: string;
}

export function StartSessionButton({
  session,
  size = "sm",
  variant = "ghost",
  className,
  label = "Démarrer",
}: StartSessionButtonProps) {
  const { startSession, session: activeSession, openOverlay } = useActiveSession();

  const isThisActive = activeSession?.id === session.id;
  const isIconOnly = size === "icon";

  const handleClick = () => {
    if (isThisActive) {
      openOverlay();
    } else {
      startSession(session);
    }
  };

  const displayLabel = isThisActive ? "Reprendre" : label;

  return (
    <Button
      size={size}
      variant={isThisActive ? "default" : variant}
      className={className}
      onClick={handleClick}
      aria-label={isIconOnly ? displayLabel : undefined}
      title={isIconOnly ? displayLabel : undefined}
    >
      <Play className={isIconOnly ? "h-3.5 w-3.5" : "h-3 w-3 mr-1"} />
      {!isIconOnly && displayLabel}
    </Button>
  );
}
